module.exports = __webpack_public_path__ + "static/media/skip.789dff58.svg";